/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	var gglMaps = __webpack_require__(1);
	
	$(function() {
		var ShopMap_elm = $('#shopMap_id');
		var ShopMap_conf = ShopMap_elm.data('map_conf');
		var ShopMk_conf = ShopMap_elm.data('mk_conf');
		gglMaps.map_view(ShopMap_conf,'#shopMap__canvas_id',ShopMk_conf);
	});
	
	// デフォルトの POI をクリック無効に(要無名関数)
	(function fixInfoWindow() {
		var set = google.maps.InfoWindow.prototype.set;
		google.maps.InfoWindow.prototype.set = function(key, val) {
			if (key === "map") {
				if (! this.get("noSupress")) {
					return;
				}
			}
			set.apply(this, arguments);
		};
	})();


/***/ },
/* 1 */
/***/ function(module, exports) {

	module.exports = {
	
	/**
	 * Googlemaps でマーカーを表示させる
	 *
	 * @method gglMaps
	 * @param {JSON} conf マップ情報
	 * @param {string} canvas 対象 ID
	 * @param {JSON} data マーカー情報
	 * 
	 */
	
		// map_view
	
		map_view: function(conf,canvas,data) {
	
			// 値をセット
			var MapConf = conf;
			var	Canvas = $(canvas)[0];
			var Center = new google.maps.LatLng(conf.lat,conf.lng);
			var Zoom = conf.zoom || 15;
	
			// 地図のオプション設定
			var Options = {
				zoom: Zoom,
				center: Center,
				mapTypeId: google.maps.MapTypeId.ROADMAP,
				mapTypeControl: false,
				zoomControl: true,
				streetViewControl: false,
				panControl: false
			};
	
			// 地図を表示
			var Mapping = new google.maps.Map(Canvas, Options);
	
			// マーカー情報あり
			if (data) {
	
				// 値をセット
				var Data = data;
				var Data_len = Data.mkInfo.length;
	
				// マーカーを1つ表示
				if (1 === Data_len) {
					Add = new google.maps.Marker({
						position: new google.maps.LatLng(Data.mkInfo[0].lat,Data.mkInfo[0].lng),
						icon: Data.mkInfo[0].markerImg,
						map: Mapping,
						draggable: false
					});
				}
	
				// マーカーを複数表示
				if (1 < Data_len) {
	
					// まず0番目の経緯度をセット
					var Center_minLat = Data.mkInfo[0].lat;
					var Center_minLng = Data.mkInfo[0].lng;
					var Center_maxLat = Data.mkInfo[0].lat;
					var Center_maxLng = Data.mkInfo[0].lng;
	
					// JSON を紐解く
					for (var i = 0; i < Data.mkInfo.length; i++) {
						Add = new google.maps.Marker({
							position: new google.maps.LatLng(Data.mkInfo[i].lat,Data.mkInfo[i].lng),
							map: Mapping,
							icon: Data.mkInfo[i].markerImg,
							draggable: false
						});
	
						// 以降の経緯度の差をみて、最小値最大値をセット
						if (Data.mkInfo[i].lat <= Center_minLat){
							Center_minLat = Data.mkInfo[i].lat;
						}
						if (Data.mkInfo[i].lat > Center_maxLat){
							Center_maxLat = Data.mkInfo[i].lat;
						}
						if (Data.mkInfo[i].lng <= Center_minLng){
							Center_minLng = Data.mkInfo[i].lng;
						}
						if (Data.mkInfo[i].lng > Center_maxLng){
							Center_maxLng = Data.mkInfo[i].lng;
						}
	
					}
	
					// LatLngBounds（自動調整） 形式にセット
					var gMp_SouthWest = new google.maps.LatLng(Center_maxLat, Center_minLng);
					var gMp_NorthEast = new google.maps.LatLng(Center_minLat, Center_maxLng);
					var gMp_Bounds = new google.maps.LatLngBounds(gMp_SouthWest, gMp_NorthEast);
	
					// ズーム・中心地を調整してセット
					Mapping.fitBounds(gMp_Bounds);
	
				}
	
				// マーカー情報なし
				else {
					return false;
				}
	
			}
		}
	};


/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** access.js
 **/